import React from "react";

/** Stroke icons drawn for this app, so every screen uses the same weight and corners. */
const Icon = ({ size = 24, strokeWidth = 2, children, fill = "none", ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill}
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...rest}
  >
    {children}
  </svg>
);

// Points to the start edge (right in Hebrew); flipped in English by the caller's dir.
export const BackIcon = (p) => (
  <Icon strokeWidth={2.2} {...p} className={`rtl:rotate-0 ltr:rotate-180 ${p.className || ""}`}>
    <path d="M5 12h14M13 6l6 6-6 6" />
  </Icon>
);
export const ForwardIcon = (p) => (
  <Icon strokeWidth={2.4} {...p} className={`ltr:rotate-180 ${p.className || ""}`}>
    <path d="M15 6l-6 6 6 6" />
  </Icon>
);
export const HeartIcon = ({ filled, ...p }) => (
  <Icon fill={filled ? "currentColor" : "none"} {...p}>
    <path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z" />
  </Icon>
);
export const SearchIcon = (p) => (
  <Icon strokeWidth={2.2} {...p}>
    <circle cx="11" cy="11" r="7" />
    <path d="M20 20l-3.5-3.5" />
  </Icon>
);
export const FilterIcon = (p) => (
  <Icon strokeWidth={2.2} {...p}>
    <path d="M4 7h10M18 7h2M4 17h4M12 17h8" />
    <circle cx="16" cy="7" r="2" />
    <circle cx="10" cy="17" r="2" />
  </Icon>
);
export const HomeIcon = (p) => (
  <Icon {...p}>
    <path d="M4 11l8-7 8 7v9H4z" />
    <path d="M10 20v-5h4v5" />
  </Icon>
);
export const BagIcon = (p) => (
  <Icon {...p}>
    <path d="M6 7h12l-1 13H7L6 7z" />
    <path d="M9 7a3 3 0 0 1 6 0" />
  </Icon>
);
export const CardIcon = (p) => (
  <Icon {...p}>
    <rect x="3" y="6" width="18" height="13" rx="2" />
    <path d="M3 10h18" />
  </Icon>
);
export const BellIcon = (p) => (
  <Icon {...p}>
    <path d="M4 17h16" />
    <path d="M6 17a6 6 0 0 1 12 0" />
    <path d="M12 8V6" />
    <path d="M3 20h18" />
  </Icon>
);
export const CheckIcon = (p) => (
  <Icon strokeWidth={2.2} {...p}>
    <path d="M5 12l5 5 9-10" />
  </Icon>
);
export const CloseIcon = (p) => (
  <Icon strokeWidth={2.2} {...p}>
    <path d="M6 6l12 12M18 6L6 18" />
  </Icon>
);

export const AppleLogo = ({ size = 18, color = "#000000" }) => (
  <svg width={size} height={size * 1.2} viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill={color}
      d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"
    />
  </svg>
);

export const GoogleLogo = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z" />
    <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z" />
    <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z" />
    <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.087 5.571l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z" />
  </svg>
);
